import { render, staticRenderFns } from "./BaseFormAutocomplete.vue?vue&type=template&id=dcd44c10"
import script from "./BaseFormAutocomplete.vue?vue&type=script&lang=js"
export * from "./BaseFormAutocomplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports